import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-service-error',
  templateUrl: './service-error.component.html',
  styleUrls: ['./service-error.component.scss']
})
export class ServiceErrorComponent {

  public isCes: boolean = false;
  public isEqh: boolean = false;

  constructor(private router: Router) { }
  
    ngOnInit() {
  	console.log(this.router.url);
  	if(this.router.url.indexOf('/ces') !== -1){
      this.isCes = true;
    }else{
      this.isEqh = true;
    }
  }

}
